import {CdkCopyToClipboard} from '@angular/cdk/clipboard'
import {CdkOverlayOrigin} from '@angular/cdk/overlay'
import {Component, computed, inject, OnInit, signal} from '@angular/core'
import {MatButton} from '@angular/material/button'
import {MatCard, MatCardContent} from '@angular/material/card'
import {
  MatExpansionPanel,
  MatExpansionPanelHeader
} from '@angular/material/expansion'
import {MatIcon} from '@angular/material/icon'
import {MatDivider} from '@angular/material/list'
import {MatSnackBar} from '@angular/material/snack-bar'
import {ActivatedRoute, Router} from '@angular/router'
import {QRComponent} from '@samtycke/qrcode-fe'
import {filter, switchMap, tap} from 'rxjs'
import {HOME_PATH} from '../../general/shared'
import {ProjectService} from '../../services/project.service'
import {Tutorials} from '../tutorials/tutorials'

@Component({
  selector: 'smt-sign',
  imports: [
    MatIcon,
    MatCard,
    MatCardContent,
    QRComponent,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatButton,
    CdkCopyToClipboard,
    MatDivider,
    Tutorials,
    CdkOverlayOrigin
  ],
  templateUrl: './sign.html',
  styleUrl: './sign.scss',
})
export class Sign implements OnInit {

  public readonly projectService = inject(ProjectService)
  public projectId = signal('')

  public selectedProject = computed(() => this.projectService.projects()
    .find(project => project.id === this.projectId()))

  private readonly route = inject(ActivatedRoute)
  private readonly router = inject(Router)
  private readonly snackBar = inject(MatSnackBar)

  public ngOnInit() {
    this.projectService.getProjects()
      .pipe(
        switchMap(() => this.route.params),
        tap(params => this.projectId.set(params.projectId)),
        filter(params => {
          return !this.projectService.projects().some(project => project.id === params.projectId)
        }),
        filter(Boolean)
      ).subscribe(() => this.router.navigate(['/', HOME_PATH]).then())
  }

  public linkCopiedSnackBar() {
    this.snackBar.open('Länken kopierad', 'Okej!', {duration: 5000})
  }
}
